module.exports = __webpack_public_path__ + "img/49.311fc4de.jpg";